<template>
  <v-container fluid grid-list-md>
    <v-card
      class="mt-2 mx-auto rounded"
      max-width="800"
      color="white"
      elevation-20
    >
      <center>
        <img
          class="mt-3 mb-3 hidden-md-and-up"
          src="@/assets/img/logo-md.png"
          style="max-width=200px;"
        />
        <img
          class="mt-3 mb-3 hidden-sm-and-down"
          src="@/assets/img/logo-md.png"
          style="max-width=400px;"
        />
      </center>

      <v-sheet
        class="py-4 ml-3"
        color="amber darken-1"
        max-width="calc(100% - 32px)"
      >
        <h1
          class="display-2 text-xs-center font-weight-bold condensed white--text"
        >
          Disabled Account
        </h1>
      </v-sheet>

      <v-card-text class="pb-5 pl-4 mt-2">
        <div class="headline mb-2">Bummer</div>
        <div class="subheading font-weight-light">
          This account has been disabled. If you think this an error, contact
          us.
        </div>
        <v-divider class="my-2"></v-divider>
        <v-icon class="mr-2" small>
          alarm
        </v-icon>
        <span class="text-right font-weight-light"
          >{{ new Date().toLocaleDateString() }}
          {{ new Date().toLocaleTimeString() }}</span
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- mailto -->
        <v-btn
          href="mailto:support@sustainesolutions.com?subject=Sustaine%20Error%20500"
          small
          color="primary"
          round
          dark
          elevation-4
          pr-2
          ><span class="white--text">Contact Us</span></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: 'NotAuthed'
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  img {
    max-width: 200px;
  }
  h1 {
    font-size: 12px;
  }
}
</style>
